import config from './src/config'

export default config
